export enum ZoomDirection {
  zoomIn = 'zoomIn',
  zoomOut = 'zoomOut',
}
